import { render, staticRenderFns } from "./content-list.vue?vue&type=template&id=06897262&scoped=true"
import script from "./content-list.vue?vue&type=script&lang=js"
export * from "./content-list.vue?vue&type=script&lang=js"
import style0 from "./content-list.vue?vue&type=style&index=0&id=06897262&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06897262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06897262')) {
      api.createRecord('06897262', component.options)
    } else {
      api.reload('06897262', component.options)
    }
    module.hot.accept("./content-list.vue?vue&type=template&id=06897262&scoped=true", function () {
      api.rerender('06897262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/content-list.vue"
export default component.exports